import SidebarMedia from '@/components/_blog-updates/SidebarMedia';
import { CraftSidebarMediaProps } from './CraftSidebarMedia.types';
import { mapBlockToSidebarMediaProps } from './CraftSidebarMedia.utils';

const CraftSidebarMedia = ({ block }: CraftSidebarMediaProps) => {
  const props = mapBlockToSidebarMediaProps(block);

  return <SidebarMedia {...props} />;
};

export default CraftSidebarMedia;
